import BankAccountInput from '@debbie/iris/dist/components/economy/BankAccountInput.js'
import THEME from '@debbie/iris/dist/theme.js'
import { styled } from 'styled-components'

export const AccountInput = styled(BankAccountInput)`
  justify-content: center;
  margin-right: 1em;
`

export const Language = styled.div<{ active: boolean }>`
  display: inline-block;
  margin-right: 5px;
  border-radius: 100%;
  height: 24px;
  width: 24px;

  svg {
    cursor: pointer;
    height: 20px;
    padding: 2px;
  }

  border: 2px solid
    ${(props) => (props.active ? THEME.COLOR_ACCENT : 'transparent')};

  transition: border 0.2s;
`

export const Info = styled.span`
  font-size: 0.9em;
`

export const Header = styled.h2`
  margin-top: 2em;
`

export const OnlyMobile = styled.div`
  display: none;

  @media only screen and (max-device-width: 600px) {
    display: block;
  }
`
export const OnlyNotMobile = styled.div`
  display: block;

  @media only screen and (max-device-width: 600px) {
    display: none;
  }
`

export const Intro = styled.div`
  h1 {
    font-weight: 400;
    span {
      font-weight: 700;
    }
  }

  p {
    color: ${THEME.DARK_COLOR_SECONDARY};
  }
`
